
import { useState, createContext, useEffect } from 'react';
import utilsMaster from '../Connections/_Utils/utilsMaster';

export const MasterContext = createContext();

export const MasterContextProvider = (props) => {

    const [mastercon, setMastercon] = useState();

    
    useEffect(() => {
        if (!mastercon) {
            getMaster();
        }

    }, [mastercon]);

    const getMaster = async () => {
        try {
            const theMaster = await utilsMaster.getMaster();
            setMastercon(theMaster);

        } catch (error) {
            console.error('Error fetching the master:', error);
        }
    };





    return (
        <MasterContext.Provider value={[mastercon, setMastercon]}>
            {props.children}
        </MasterContext.Provider>
    );
};
